exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home-cat[data-v-6aa3e470] {\n  position: relative;\n}\n@media (max-width: 768px) {\n.new-collection[data-v-6aa3e470] {\n    padding-top: 0;\n}\n}\n.menu-bottom[data-v-6aa3e470] {\n  display: block;\n  margin-top: -50px;\n}\n", ""]);

// exports
